module.exports = __webpack_public_path__ + "img/ondulacao.03206c00.svg";